import { QuickReviewListRequest } from "../../../../data-model/quickReviewModel";

/**
 * Generates an array of Quick Review list payloads for pages 0 through
 * batchNumber, used to restore previously loaded pages on re-mount.
 *
 * @param filterPayload - Base Quick Review list parameters (page size)
 * @param batchNumber - The last batch (page) index that was previously fetched
 * @returns Array of payloads, one per page from 0 to batchNumber
 */
export const recursivelyGeneratePayloadForInitialFetch = (
  filterPayload: QuickReviewListRequest,
  batchNumber: number,
): QuickReviewListRequest[] => {
  const arraysFromBatchNumber = Array.from(
    { length: batchNumber + 1 },
    (_, index) => index,
  );
  return arraysFromBatchNumber.map((index) => ({
    ...filterPayload,
    page: index,
  }));
};
